import React, { useEffect, useState } from "react";
import style from "../../index.module.scss";
import AddPhone from "./addPhone";
import ChangePhone from "./changePhoneDom";
import { getTranslatedCookiesSettings } from "@/app/csr-src/data/consts/accountEnum";
import { useTranslation } from "@/i18n/client";

   
const PhoneVerification = React.forwardRef(({ flag, userInfo, jumpToDialog, handleClose, freezeAccount, continueFn }: any, ref) => {
  const { t } = useTranslation();
  // 使用翻译后的设置
  const { AccountTypeEnum } = getTranslatedCookiesSettings(t);
  const [pageFlag, setPageFlag] = useState("");
  const [page, setPage] = useState("");

  useEffect(() => {
    if (flag) {
      setPageFlag(flag);
      setPage(flag)
    }
  }, [flag]);

  const goAddPhone = () => {
    // pageFlag在添加手机号页面还有交互处理，用来标识当前是修改还是添加，不动这个变量
    setPageFlag(AccountTypeEnum.CHANGE_PHONE);
    // 标识展示什么页面
    setPage(AccountTypeEnum.ADD_PHONE);
  };
  // 跳转到某个页面
  // const continueFn = (data: { type: string; flag: string; successText: string }) => {
  //   jumpToDialog(data);
  // };
  return (
    <div className={style.email__wrap}>
      {/* --------------------------------- 添加手机号 --------------------------------- */}
      {(page == AccountTypeEnum.ADD_PHONE) && (
        <AddPhone ref={ref} freezeAccount={freezeAccount} userInfo={userInfo} pageFlag={pageFlag} continueFn={continueFn} jumpToDialog={jumpToDialog} clonePop={continueFn} handleClose={handleClose}/>
      )}
      {/* --------------------------------- 修改手机号 --------------------------------- */}
      {page == AccountTypeEnum.CHANGE_PHONE && <ChangePhone userInfo={userInfo} goAddPhone={goAddPhone} />}
    </div>
  );
});

export default PhoneVerification;
